// extracted by css-extract-rspack-plugin
export default {"highlighted":"highlighted-_BKvWM"};